import { authInstance } from "./axios";

export const getAll = async (keyword = '', role_id = null, extraFilters = {}, pagination = {}) => {
    const params = {};
    if (typeof keyword === 'string' && keyword.trim() !== '') {
        params.keyword = keyword;
    }
    if (role_id !== null && role_id !== '') {
        params.role_id = role_id;
    }
    Object.entries(extraFilters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            params[key] = value;
        }
    });
    Object.entries(pagination).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            params[key] = value;
        }
    });

    const response = await authInstance.get('user', { params });
    return response;
};


export const addNew = async (data) => {
    const config = data instanceof FormData ? {
        headers: { 'Content-Type': 'multipart/form-data' }
    } : undefined;
    const response = await authInstance.post(`user`, data, config)
    return response
};

export const update = async (id, data) => {
    if (data instanceof FormData) {
        const response = await authInstance.post(`user/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        return response
    }
    const response = await authInstance.put(`user/${id}`, data)
    return response
};

export const profile = async () => {
    const response = await authInstance.get(`profile`)
    return response
};

export const updateProfile = async (data) => {
    const response = await authInstance.post(`profile`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response
};

export const deleteFunction = async (id) => {
    const response = await authInstance.delete(`user/${id}`)
    return response
};

export const importUser = async (formData) => {
    const response = await authInstance.post(`/import-user`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
    return response
}

export const exportData = async (filters = {}) => {
    const response = await authInstance.get(`export-user`, {
        params: filters,
        responseType: "blob",
        headers: {
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
    })
    return response
};
export const updateRole = async (id, data) => {
    const response = await authInstance.post(`users/${id}/update-roles`, data)
    return response
};

export const getNormalUser = async (keyword = null, params = {}) => {
    const response = await authInstance.get(`/users/normal`, {
        params: {
            ...params,
            ...(keyword ? { keyword } : {})
        }
    })
    return response
}

export const addLevel = async (data) => {
    const response = await authInstance.post(`/level-user`, data)
    return response
}

export const getUserLevelHistory = async (id) => {
    const response = await authInstance.get(`history-level-user/${id}`)
    return response
};

export const getHistoryExam = async (id) => {
    const response = await authInstance.get(`get-history-exam-by-user-id/${id}`)
    return response
}

// {
//     "user_id": 5,
//     "new_password": "mypassword123"
// }
export const resetPasswordByAdmin = async (data) => {
    const response = await authInstance.post(`reset-password-by-admin/`, data)
    return response
}
